import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { DiscountTypes } from "@/api/AppApi/services/home/interfaces/IProduct";
import ProductImg from "@/app/components/common-builder/product/product-box/product-box-helpers/product-box-image/ProductImg";
import { Col } from "@/utils/bootstrap";

interface Props {
  image_url: string;
  is_new: boolean;
  discount_amount: number;
  has_discount: boolean;
  discount_type?: DiscountTypes;
  discount?: number;
  outOfStock?: boolean;
}

const CartItemImg: React.FC<Props> = ({
  image_url,
  is_new,
  discount_amount,
  has_discount,
  discount_type,
  discount,
  outOfStock = false,
}) => {
  const getCompanty = useGetCompanyQuery();
  const theme = getCompanty?.data?.result?.theme;
  return (
    <Col className="p-0 col-auto">
      <ProductImg
        discount={discount}
        className="item-image-cart-container"
        src={image_url}
        size={Size.small}
        is_new={is_new}
        discount_amount={discount_amount}
        discount_type={discount_type}
        has_discount={has_discount}
        priority
        imgWidth={96}
        imgHeight={96}
        theme={theme!}
        outOfStock={outOfStock}
      />
    </Col>
  );
};

export default CartItemImg;
